type TrackingEventMap = {
	// Global search
	global_search_completed: { search_term: string; results_count: number }
	global_search_result_selected: {
		search_term: string
		result_type: string
		result_name: string
	}

	// Navigation
	navigation_used: {
		navigation_type: 'main_menu' | 'mobile_menu' | 'breadcrumb'
		navigation_item: string
	}

	// Bookmarks
	page_bookmark_added: { page_title: string; page_url: string }
	page_bookmark_removed: { page_title: string; page_url: string }

	// Sharing
	page_shared: { share_method: string }

	// Local search (page-level)
	search_completed: { search_term: string; results_count: number }
	search_results_page_changed: { page_number: number; search_term: string }

	// Filters
	filter_applied: { filter_name: string; filter_value: string }
	filter_removed: { filter_name: string; filter_value: string }
	all_filters_cleared: Record<string, never>

	// Sort & view
	sort_completed: { sort_option: string }
	view_mode_changed: { view_mode: string }

	// Glossary
	glossary_term_opened: { term_name: string }

	// Content pages
	content_page_key_link_clicked: { link_name: string }

	// Downloads
	file_download_completed: { file_name: string; file_type: string }

	// Case collection
	case_collection_tab_selected: { tab_name: string }
	case_image_viewed: { case_title: string; image_name: string }
	case_image_download: { case_title: string; image_name: string }
	case_video_viewed: { case_title: string; video_name: string }
	case_testimonial_copied: { case_name: string; testimonial_author: string }

	// Hardware catalogue
	hardware_catalog_sort_by: {
		sort_option: string
		sort_direction: 'asc' | 'desc'
	}
	hardware_catalog_tab_selected: { tab_name: string }
	hardware_catalog_select_all: Record<string, never>
	hardware_catalog_compare: { items: string[] }
	hardware_catalog_filehub_opened: { item_name: string }
	hardware_catalog_view_action: { item_name: string }
	hardware_catalog_export_completed: { export_type: string }
	hardware_related_file_downloaded: {
		item_name: string
		file_name: string
		file_category: string
	}
	hardware_related_file_copied: {
		item_name: string
		file_name: string
		file_category: string
	}

	// Video
	video: {
		video_action: 'play' | 'pause' | 'ended' | 'progress'
		video_url: string
		video_percent?: number
		video_title?: string
	}

	// Brand & Asset Portal
	brand_portal_nav_used: { brand: string; section: string }
	brand_portal_search_completed: {
		brand: string
		search_term: string
		results_count: number
	}
	brand_portal_search_result_selected: {
		brand: string
		search_term: string
		result_name: string
		result_type: string
	}
	brand_portal_asset_downloaded: {
		brand: string
		section: string
		asset_name: string
		file_type: string
	}
	brand_portal_cta_clicked: {
		brand: string
		section: string
		cta_title: string
		action_type: string
	}
	brand_portal_color_copied: {
		brand: string
		color_name: string
		color_format: string
	}
	brand_portal_key_visual_viewed: { brand: string; image_name: string }
	brand_portal_tab_selected: { brand: string; section: string; tab_name: string }
	brand_portal_checklist_item_toggled: {
		brand: string
		item_name: string
		checked: boolean
	}
	brand_portal_contact_clicked: { brand: string; contact_name: string }
}

export function trackEvent<K extends keyof TrackingEventMap>(
	event: K,
	...args: TrackingEventMap[K] extends Record<string, never>
		? []
		: [data: TrackingEventMap[K]]
): void {
	if (typeof window === 'undefined') return
	const data = args[0] ?? {}
	window.dataLayer?.push({ event, ...data })
}

export function setUserContext(context: {
	user_id: string
	user_role: string
}): void {
	if (typeof window === 'undefined') return
	window.dataLayer?.push(context)
}
